module.exports = __webpack_public_path__ + "static/media/masterclass.edb7267b.mp4";